import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_s_btn = _resolveComponent("s-btn")!

  return (_openBlock(), _createBlock(_component_s_btn, {
    type: "light",
    class: "s-btn__back",
    icon: "app:arrow-norma-left",
    label: "Назад"
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }))
}